import { REVIEWS } from "../data";

const initials = (name) =>
  name.replace(/^(Sra\.|Sr\.|Dona|Chef|Síndico|Família)\s/, "").split(" ").slice(0, 2).map((w) => w[0]).join("").toUpperCase();

export const Testimonials = () => (
  <section className="section" id="avaliacoes" data-testid="testimonials-section">
    <div className="container">
      <span className="section-tag">Prova social estilo Google</span>
      <h2>Avaliações de clientes do litoral</h2>
      <p className="lead">Atendimento avaliado com 5 estrelas por moradores, veranistas, síndicos e comerciantes de todo o litoral paulista.</p>
      <div className="reviews">
        {REVIEWS.map((r, i) => (
          <article className="review" key={i} data-testid={`review-card-${i}`}>
            <div className="stars" aria-label="5 estrelas">★★★★★</div>
            <p>"{r.text}"</p>
            <div className="who">
              <span className="avatar">{initials(r.name)}</span>
              <div>
                <b>{r.name}</b>
                <span>{r.place}</span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);
